import { ShieldCheck, BadgeCheck, Stethoscope, Truck, CreditCard, MapPin } from "lucide-react";

const ITEMS = [
    { icon: BadgeCheck, label: "Signia Certified Partner" },
    { icon: ShieldCheck, label: "Powered by HearClear" },
    { icon: Stethoscope, label: "RCI-Certified Audiologists" },
    { icon: Truck, label: "Free Pan-India Delivery" },
    { icon: CreditCard, label: "No-Cost EMI Available" },
    { icon: MapPin, label: "40+ HearClear Clinics" },
];

export default function TrustStrip() {
    return (
        <section className="border-y border-[#E5E7EB] bg-white" data-testid="trust-strip">
            <div className="container-x py-7 md:py-9">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-5 items-center">
                    {ITEMS.map((it, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <span className="w-9 h-9 rounded-full bg-[#003E4D]/[0.07] flex items-center justify-center text-[#003E4D] shrink-0">
                                <it.icon size={16} />
                            </span>
                            <p className="text-[12.5px] md:text-[13px] font-medium text-[#1a1a1a] leading-tight">
                                {it.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
